import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { InjectorModule } from '@app/injector.module';
import { pageResolver } from '@core/services/page/page-resolver';
import { EditorInlineModule } from '../editor/pages/editorinline.modules';

const routes: Routes = [
  {
    path: '**',
    loadComponent: () => import('./pages/main-page/main-page.component').then(m => m.MainPageComponent),
    pathMatch: 'full',
    resolve: {
      pageData: pageResolver,
    },
  },
];

@NgModule({
  imports: [
    BrowserAnimationsModule,
    InjectorModule,
    RouterModule.forChild(routes),
    EditorInlineModule,
  ],
})
export class MainModule {
}
